import React from "react";
import DaumPostcode from "react-daum-postcode";
import "./post.scss";

const Post = (props) => {
  const complete = (data) => {
    let fullAddress = data.address;
    let extraAddress = "";

    if (data.addressType === "R") {
      if (data.bname !== "") {
        extraAddress += data.bname;
      }
      if (data.buildingName !== "") {
        extraAddress +=
          extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
    }
    // console.log(data)
    // console.log(fullAddress)
    // console.log(data.zonecode)
    props.setcompany({
      ...props.company,
      address: fullAddress,
      zonecode: data.zonecode,
    });

    props.showmodal(false);
    props.setPostNum(data.zonecode);
    props.setAddress1(fullAddress);
  };

  return (
    <div>
      <DaumPostcode className="postmodal" autoClose onComplete={complete} />
    </div>
  );
};

export default Post;
